<template>
    <div>
        <Card>
            <template slot="title">
                Currencies
            </template>
            <template slot="actions">
                <b-btn
                    size="sm"
                    variant="primary"
                    @click="openAddCurrencyModal"
                >
                    Add Currency
                </b-btn>
            </template>
            <template>
                <b-table
                    :fields="currency_table_fields"
                    :items="currencies"
                >
                    <template #cell(actions)="data">
                        <div v-if="!data.item.is_base_currency" class="text-right">
                            <b-btn
                                size="sm"
                                variant="link"
                                @click="openEditModal(data.index)"
                            >
                                <i class="fa fa-pencil" />
                            </b-btn>
                        </div>
                    </template>
                </b-table>
            </template>
        </Card>

        <CostableCurrenciesAddCurrencyModal />
        <CostableCurrenciesEditCurrencyModal />
    </div>
</template>

<script>
import Card from '@/components/Card';
import CostableCurrenciesAddCurrencyModal from './CostableCurrenciesAddCurrencyModal';
import CostableCurrenciesEditCurrencyModal from './CostableCurrenciesEditCurrencyModal';

export default {

    components: {
        Card,
        CostableCurrenciesAddCurrencyModal,
        CostableCurrenciesEditCurrencyModal,
    },

    data() {
        return {
            currency_table_fields: [
                'label',
                'exchange_rate',
                {
                    key: 'actions',
                    label: '',
                },
            ],
        };
    },

    computed: {
        currencies() {
            return this.$store.getters['costable/currencies'];
        },
    },

    methods: {
        openAddCurrencyModal() {
            this.$eventBus.$emit(this.$events.openAddCurrencyModal);
        },
        openEditModal(currencyIndex) {
            const currency = this.currencies[currencyIndex];
            this.$eventBus.$emit(this.$events.openEditCurrencyModal, {
                currencyId: currency.currency_id,
                label: currency.label,
                exchangeRate: currency.exchange_rate,
            });
        },
    },

};
</script>
